import initState1 from '../../softdata.json';
const initState = {
    ...initState1[0].hardware
}
const hardwareReducer = (state = initState, action) => {
    return state;
}
export default hardwareReducer
